import { FormControl, InputLabel, MenuItem, Select, FilledInput,  Typography } from '@mui/material';
import { GridPaginationModel, GridSortModel, DataGridPro, GridPagination,  } from '@mui/x-data-grid-pro';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { matDropDownStyle } from '../../assets/style/material/matSyles';
import { months } from '../../constants/dates';
import { getDateInWeekDayMonthDateFormat } from '../../helpers/dateHelpers';
import { useSdoAdminEligibilityCriteriaProvider } from '../../providers/SdoAdminEligibilityCriteriaProvider';
// import { useProfile } from '../../providers/Profile';
import { useSdoAdminReportsProvider } from '../../providers/SdoAdminReportsProvider';
import AcDialog from '../AcDialog/AcDialog';
import "../AppSelect/AppSelect.scss";
import { IPADVIEWCONSTANTS } from '../SpecialDayOffAdminReport/UsageReportHelper';
import './SdoAdminReportDetailsReqList.scss'
import { Link } from "react-router-dom";
import { getStyleForStatus, positionReqStatusType, requestlistNoData, sdoCycleStatus, sortAlphabetic, sortDateComparator, sortStatusComparator, isReqApproved } from './SdoAdminReportHelper';
import { useHistory } from "react-router-dom";

export default function SdoAdminReportDetailsReqList({ sdoReqList, setSdoReqList, isAllPositions, setSdoReqListLoading, sdoReqListObject, setManualAction, manualAction, status, availabilityUpdatedByOther, renderedPosition }) {
    const { t } = useTranslation();
    const sdoAdminReportsContext = useSdoAdminReportsProvider();
    const sdoAdminEligibilityCriteriaContext = useSdoAdminEligibilityCriteriaProvider();
    const dropDownClasses = matDropDownStyle();
    const selectClass = `${dropDownClasses.select} ${dropDownClasses.selectForSdoRequestFilter}`;
    // const [page, setPage] = useState(0);
    // const [rowsPerPageOptions, setRowsPerPageOptions] = useState([25, 50, 100]);
    const [sortModel, setSortModel] = React.useState<GridSortModel>([]);
    const [viewAllClicked, setViewAllClicked] = useState(false);
    const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
        page: 0,
        pageSize: 25
    });
    const [onEditClick, setOnEditClick] = useState(false);
    const sdoDecision = {
        Approve: ["N/A"],
        Decline: ["Seniority",
            "Training",
            "Vacation",
            "Other"]
    };
    const [reason, setReason] = useState<any>('N/A');
    const [decision, setDecision] = useState('Approve');
    const [rowId, setRowId] = useState(0);
    const [transactionId, setTransactionId] = useState(0);
    const [openIpadDecision, setOpenIpadDecision] = React.useState(false);
    const [openDesktopDecision, setOpenDesktopDecision] = React.useState(false);
    const [openDesktopReason, setDesktopOpenReason] = React.useState(false);
    const [openIpadReason, setIpadOpenReason] = React.useState(false);
    const [open, setOpen] = useState(false);
    const [isIpadView, setIsIpadView] = useState(false);
    const [sdoMonthYear, setSdoMonthYear] = useState<any>({ sdoMonth: '', sdoYear: '', sdoMonthYearString: '' });
    const [position, setPosition] = useState('');
    const [windowContainer, setwindowContainer] = useState('');
    const [viewport, setViewport] = useState('');
    const [reasonList, setReasonsList] = useState(['N/A']);
    const [disable, setDisable] = useState(true);
    const [empId, setEmpId] = useState("");
    let history = useHistory();
    const handleClose = () => {
        setOpen(false);
        setOnEditClick(false);
        handlePreviousHeight();
    }

    const decisionList = Object.keys(sdoDecision).map(key => ({
        name: key
    }));

    
    const saveEditReq = async () => {
        const sdoEditRecommRequestObj = {
            "sdoYear": sdoMonthYear.sdoYear,
            "sdoMonth": sdoMonthYear.sdoMonth,
            "updatedStatus": decision?.toUpperCase(),
            "reason": reason || '',
            "employeeId": empId,
            "transactionId": transactionId
        }
        setSdoReqListLoading(true);
        await sdoAdminReportsContext.editSdoStatusReportRecommendation(sdoEditRecommRequestObj);
        setManualAction(true);        
    }

    useEffect(()=>{
        if(availabilityUpdatedByOther){
            setSdoReqListLoading(true);
            sdoReqListObject.reset = false;
            sdoAdminReportsContext.getSdoReqListData(sdoReqListObject);
        }        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[availabilityUpdatedByOther]);

    const approveDeclineRequest = async() => {
        setOpen(false);
        setOnEditClick(false);

        if(!availabilityUpdatedByOther){
            await saveEditReq();
        }
        setSdoReqListLoading(true);
        sdoReqListObject.reset = false;
        sdoAdminReportsContext.getSdoReqListData(sdoReqListObject);
        
    }

    const removeData = {

        title: `${decision === 'Approve' ? t('specialDayOff.sdoReport.approveRequestTitle') : t('specialDayOff.sdoReport.declineRequestTitle')}`,
        description: `${decision === 'Approve' ? t('specialDayOff.sdoReport.approveRequestDescription') : t('specialDayOff.sdoReport.declineRequestDescription')}
       </br> ${sdoMonthYear?.sdoMonthYearString} ${'-'} <b>${position.split(' ').join('|')} </b>.`,
        actionLabel: t('specialDayOff.sdoReport.cancel'),
        handleAction: handleClose,
        secondaryActionLabel: `${decision === 'Approve' ? t('specialDayOff.sdoReport.approveRequest') : t('specialDayOff.sdoReport.declineRequest')}`,
        handleSecondaryAction: approveDeclineRequest,
    }

    const handleDesktopOpenCloseDecision = () => {
        setOpenDesktopDecision(!openDesktopDecision);
    };
    const handleIpadOpenCloseDecision = () => {
        setOpenIpadDecision(!openIpadDecision);
    };
    const handleDesktopOpenCloseReason = () => {
        setDesktopOpenReason(!openDesktopReason);
    };
    const handleIpadOpenCloseReason = () => {
        setIpadOpenReason(!openIpadReason);
    };
    const iconComponentDesktopDecision = () => {
        return (
            <div onClick={handleDesktopOpenCloseDecision} className="icon_container">
                <i className="icon-chevron-thin-down" />
            </div>
        )
    }
    const iconComponentIpadDecision = () => {
        return (
            <div onClick={handleIpadOpenCloseDecision} className="icon_container">
                <i className="icon-chevron-thin-down" />
            </div>

        )
    }
    const iconComponentDesktopReason = () => {
        return (
            <div onClick={handleDesktopOpenCloseReason} className="icon_container">
                <i className="icon-chevron-thin-down" />
            </div>
        )
    }
    const iconComponentIpadReason = () => {
        return (
            <div onClick={handleIpadOpenCloseReason} className="icon_container">
                <i className="icon-chevron-thin-down" />
            </div>
        )
    }
    const handleSortChange = (model: GridSortModel) => {
        if (JSON.stringify(model) !== JSON.stringify(sortModel)) setSortModel(model);
    };
    const onChangeDecision = (e) => {
        const decisionSel = e.target.value;
        const reasonSel = decisionSel !== "" ? sdoDecision[decisionSel] : "";
        setDecision(decisionSel);
        setReasonsList(reasonSel);
        setReason(reasonSel[0]);
        setDisable(false);
    }
    const onChangeDesktopDecision = (e) => {
        onChangeDecision(e);
    };
    const onChangeIpadDecision = (e) => {
        onChangeDecision(e);
    };

    const onChangeDesktopReason = (e) => {

        setReason(e.target.value);
    }
    const onChangeIpadReason = (e) => {
        setReason(e.target.value);
    }
    // const handlePageSizeChange = (newPageSize) => {
    //     if (newPageSize > 100) {
    //         setViewAllClicked(true);
    //     }
    //     else {
    //         setViewAllClicked(false);
    //     }
    //     return setPageSize(newPageSize);
    // }
    const menuProps: any = {
        classes: {
            list: dropDownClasses.list
        },
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        getContentAnchorEl: null
    }


    const handleCancelRequest = (id, e) => {
        setOnEditClick(false);
        handlePreviousHeight();
    }

    const handleEditRequestRecomm = async (row, e) => {
        setOpen(true);
        setPosition(row.position);
        handlePreviousHeight();
    }
    const handlePreviousHeight = () => {
        const windowContainerEle: any = document.querySelector('.MuiDataGrid-main');
        const viewPortEle: any = document.querySelector('.MuiDataGrid-virtualScroller');

        if (windowContainer && viewPortEle) {
            windowContainerEle.style.height = windowContainer;
            viewPortEle.style.maxHeight = viewPortEle;
        }
    }
    const handleEditRequest = (row, e) => {
         // call limits api to check manual override
         const position = {
            base: sdoReqListObject?.base,
            equipment: sdoReqListObject?.equipment,
            rank: sdoReqListObject?.position
        }
        sdoAdminEligibilityCriteriaContext.viewPosition(position, sdoMonthYear);

        // first load current selection as in DB
        if (row?.recommendedstatus === positionReqStatusType.PENDING_DECLINE) {
            setDecision("Decline");
            setReasonsList(sdoDecision.Decline);
            const currentReason = sdoDecision.Decline.find(item => item === row?.reason);
            setReason(currentReason?.toString());
        } else {
            setDecision("Approve");
            setReasonsList(sdoDecision.Approve);
            setReason("N/A");
        }
        setDisable(false);

        const windowContainerEle: any = document.querySelector('.MuiDataGrid-main');
        const viewPortEle: any = document.querySelector('.MuiDataGrid-virtualScroller');

        if (!windowContainer && !viewport) {

            setwindowContainer(`${windowContainerEle.offsetHeight}px`);
            setViewport(`${viewPortEle.offsetHeight}px`);
        }
        if (!row.id) setOnEditClick(false);

        setOnEditClick(true);
        setRowId(row.id);
        setEmpId(row.empId);
        setTransactionId(row.transactionId);
        const newWindowContainerEle = windowContainerEle.offsetHeight;
        let windowContainerEleHeight = 0;

        windowContainerEleHeight = Number(newWindowContainerEle) + getwindowContainerWidth();
        windowContainerEle.style.height = windowContainerEleHeight + 'px';

        const newViewPortEle = viewPortEle.offsetHeight
        let viewPortEleEleHeight = 0;
        viewPortEleEleHeight = Number(newViewPortEle) + getViewPortWidth();
        viewPortEle.style.maxHeight = viewPortEleEleHeight + 'px';

    }
    const getwindowContainerWidth = () => {
        if (!isIpadView)
            return 78;
        else return 125;
    }
    const getViewPortWidth = () => {
        if (!isIpadView)
            return 108;
        else return 220;
    }
    const handleManageClick = (row, e) => {        
        const managedPilotId=row?.empId
        history.push('/sdo-admin-ec', { setLimitTabZero: 0, managedPilotId, goback: 0, pos: sdoReqListObject });
    }

    const showAllRows = () => {
        setViewAllClicked(true);
        // setPage(0);
        if (sdoReqList?.reports?.length > 100) {
            setPaginationModel({
                ...paginationModel,
                pageSize: Math.ceil(sdoReqList?.reports?.length / 25) * 25 
            });
        }
        else if (sdoReqList?.reports?.length > 50) {
            setPaginationModel({
                ...paginationModel,
                pageSize: 100
            });
        }
        else if (sdoReqList?.reports?.length > 25) {
            setPaginationModel({
                ...paginationModel,
                pageSize: 50
            });
        }
        else {
            setPaginationModel({
                ...paginationModel,
                pageSize: 25
            });
        }
    }

    useEffect(() => {
        if (isAllPositions) {
            setSortModel([
                {
                    field: 'position',
                    sort: 'asc',
                },
                {
                    field: 'seniority',
                    sort: 'asc',
                },
            ]);
        }
        else {
            setSortModel([
                {
                    field: 'seniority',
                    sort: 'asc',
                },
            ]);
        }
    }, [isAllPositions]);

    useEffect(() => {
        if (sdoReqList?.reports?.length === 0) {
            // setRowsPerPageOptions([25, 50, 100]);
            setPaginationModel({
                ...paginationModel,
                pageSize: 25
            });
        }
        else if (sdoReqList?.reports?.length > 100) {
            const allRows = Math.ceil(sdoReqList?.reports?.length / 25) * 25;
            // setRowsPerPageOptions([25, 50, 100, allRows]);
            if (viewAllClicked) {
                setPaginationModel({
                    ...paginationModel,
                    pageSize: allRows
                });
            }
        }
        else {
            // setRowsPerPageOptions([25, 50, 100]);
            if (viewAllClicked) {
                if (sdoReqList?.reports?.length > 50) {
                    setPaginationModel({
                        ...paginationModel,
                        pageSize: 100
                    });
                }
                else if (sdoReqList?.reports?.length > 25) {
                    setPaginationModel({
                        ...paginationModel,
                        pageSize: 50
                    });
                }
                else {
                    setPaginationModel({
                        ...paginationModel,
                        pageSize: 25
                    });
                }
            } else { // 1 -100
                if (paginationModel.pageSize === 25) {
                    ;
                }
                else if (paginationModel.pageSize === 50) {
                    if (sdoReqList?.reports?.length <= 25) {
                        setPaginationModel({
                            ...paginationModel,
                            pageSize: 25
                        });
                    }
                }
                else if (paginationModel.pageSize === 100) {
                    if (sdoReqList?.reports?.length <= 25) {
                        setPaginationModel({
                            ...paginationModel,
                            pageSize: 25
                        });
                    } else if (sdoReqList?.reports?.length <= 50) {
                        setPaginationModel({
                            ...paginationModel,
                            pageSize: 50
                        });
                    }
                }
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!sdoAdminReportsContext.sdoPositionsPublishData?.sdoMonth && !sdoAdminReportsContext.sdoPositionsPublishData?.sdoYear) return

        setSdoMonthYear({
            sdoMonth: sdoAdminReportsContext.sdoPositionsPublishData?.sdoMonth,
            sdoYear: sdoAdminReportsContext.sdoPositionsPublishData?.sdoYear,
            sdoMonthYearString: months[Number(sdoAdminReportsContext?.sdoPositionsPublishData?.sdoMonth) - 1] + " " + sdoAdminReportsContext?.sdoPositionsPublishData?.sdoYear
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sdoAdminReportsContext.sdoPositionsPublishData]);


    useEffect(() => {
        if (!sdoAdminReportsContext.sdoReqListData?.reports) {
            setSdoReqList({});
            setEmpId('');
            setSdoReqListLoading(false);
            return;
        }
        setEmpId('');
        setSdoReqList(sdoAdminReportsContext.sdoReqListData);
        // setPositionTotalReq(sdoAdminReportsContext.sdoReqListData?.reports?.length);
        setSdoReqListLoading(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sdoAdminReportsContext.sdoReqListData]);

    window.addEventListener('resize', windowResize);

    function windowResize() {
        const { innerWidth } = window;
        setIsIpadView(innerWidth <= IPADVIEWCONSTANTS.MAXWIDTH && innerWidth > IPADVIEWCONSTANTS.MINWIDTH);
    }

    const positionReqListColumns = [
        {
            field: 'position',
            headerName: 'Position',
            sortComparator: sortAlphabetic,
            width: 115,
            editable: false,
            renderCell: (params) => {
                return (<p>{params.row.position}</p>)

            }
        },
        
        {
            field: 'pilot', headerName: 'Pilot',
            sortComparator: sortAlphabetic,
            width:  280,
            editable: false,
            renderCell: (params) => {
                return (
                    <p>
                        <div className='table__cell--pilot' style={{ display: params.row.empId?.toString().length + params.row.pilot?.length > 20 ? 'block' : 'flex' }}>
                            <Typography className='pilot-lbl pilot-lbl--name'>{params.row.pilot}</Typography>
                            <Typography className={params.row.empId?.toString().length + params.row.pilot?.length > 20 ? 'pilot-lbl' : 'pilot-lbl pilot-lbl--ml'}>(ID {params.row.empId})</Typography>
                        </div>
                    </p>
                )
            }
        },
        {
            field: 'seniority', headerName: 'Seniority', width: 110, editable: false,
            sortComparator: sortAlphabetic,
            renderCell: (params) => {
                return (<p>{params.row.seniority}</p>)
            }
        },
        {
            field: 'aq', headerName: 'AQ', width: isAllPositions ? 66 : 80, editable: false,
            renderCell: (params) => {
                return (<p>{(params.row.aq === null || params.row.aq === 'null') ? '' : params.row.aq}</p>)
            }
        },
        {
            field: 'sdo_start_date', headerName: 'Dates Requested', width: isIpadView ? 220 : 283, editable: false,
            sortComparator: sortDateComparator,
            renderCell: (params) => {
                return (
                    <p className='position-requests__dates'>
                        <span>{(params.row.sdo_start_date && params.row.sdo_end_date && params.row.days > 1) ?
                            getDateInWeekDayMonthDateFormat(new Date(params.row.sdo_start_date)) + " - " + getDateInWeekDayMonthDateFormat(new Date(params.row.sdo_end_date)) + " "
                            : (params.row.sdo_end_date ? `${getDateInWeekDayMonthDateFormat(new Date(params.row.sdo_end_date))} ${" "} (${params.row.days} ${'day'})`                            
                            : ' ')}
                        </span>
                        <span className='position-requets__dates-days'>
                            {(params.row.days && params.row.days > 1) ? `${" "} (${params.row.days} ${'days'})`: ''}
                        </span>
                    </p>
                )
            }
        },

        {
            field: 'recommendedstatus', headerName: 'Status', width: isAllPositions ? 195 : 210,
            editable: false,
            sortComparator: sortStatusComparator,
            renderCell: (params) => {
                return (<span className="position-requests__status"
                    style={getStyleForStatus(params.row.isPreApproved ? positionReqStatusType.PREVIOUSLY_APPROVED : params.row.recommendedstatus)}>
                    {params.row.isPreApproved
                        ? isIpadView
                            ? positionReqStatusType.PREV_APPROVED
                            : positionReqStatusType.PREVIOUSLY_APPROVED
                        : params.row.recommendedstatus?.toUpperCase()}
                </span>)
            }
        },
        {
            field: 'reason', headerName: 'Reason',
            sortComparator: sortAlphabetic,
            width: isAllPositions
                ? (status && status === sdoCycleStatus.OPEN
                    ?
                    (isIpadView ? 100 : 280)
                    :
                    isIpadView ? 100 : 180)
                : (status && status === sdoCycleStatus.OPEN
                    ?
                    (isIpadView ? 105 : 400)
                    :
                    271
                ),
            editable: false,
            disableClickEventBubbling: true,
            renderCell: (params) => {
                return (
                    <>

                        <div className="sdo-report-request_row">

                            {params.row.recommendedstatus === positionReqStatusType.PENDING_APPROVAL || params.row.recommendedstatus === positionReqStatusType.PENDING_DECLINE || params.row.recommendedstatus === positionReqStatusType.REVOKED || params.row.recommendedstatus === positionReqStatusType.APPROVED || params.row.recommendedstatus === positionReqStatusType.DECLINED ?
                                <>
                                    <div className="sdo-report-request__reason-container">
                                        {onEditClick && params.row.id === rowId ?
                                            <>

                                                <div className="sdo-report-request__reason-decision-container">
                                                    <div className="sdo-report-request-select-decision">
                                                        <FormControl className="select-dropdown">
                                                            <InputLabel id='inputLabel' className={dropDownClasses.label}>{t('specialDayOff.sdoReport.decision')}</InputLabel>
                                                            <Select
                                                                className={selectClass}
                                                                MenuProps={menuProps}
                                                                labelId="select-label-decision"
                                                                value={decision}
                                                                input={<FilledInput />}
                                                                label={t('specialDayOff.sdoReport.decision')}
                                                                onChange={e => onChangeDesktopDecision(e)}
                                                                disableUnderline
                                                                IconComponent={iconComponentDesktopDecision}
                                                                open={openDesktopDecision}
                                                                onClose={handleDesktopOpenCloseDecision}
                                                                onOpen={handleDesktopOpenCloseDecision}
                                                                defaultValue={t('specialDayOff.sdoReport.approve')}
                                                            >
                                                                {decisionList.map((decision, key) => (
                                                                    <MenuItem key={key} value={decision.name}>
                                                                        {decision.name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                    <div className="sdo-report-request-select-reason">
                                                        <FormControl className="select-dropdown" disabled={disable}>
                                                            <InputLabel id='inputLabel' className={dropDownClasses.label}>{t('specialDayOff.sdoReport.reason')}</InputLabel>
                                                            <Select
                                                                className={selectClass}
                                                                MenuProps={menuProps}
                                                                labelId="select-label-reason-Desktop"
                                                                id="demo-simple-select-Desktop"
                                                                value={reason}
                                                                input={<FilledInput />}
                                                                label={t('specialDayOff.sdoReport.reason')}
                                                                disableUnderline
                                                                IconComponent={iconComponentDesktopReason}
                                                                open={openDesktopReason}
                                                                onClose={handleDesktopOpenCloseReason}
                                                                onOpen={handleDesktopOpenCloseReason}
                                                                defaultValue={t('specialDayOff.sdoReport.na')}
                                                                onChange={e => onChangeDesktopReason(e)}
                                                                disabled={disable}
                                                            >
                                                                {reasonList.map((reason, key) => (
                                                                    <MenuItem key={key} value={reason}>
                                                                        {reason}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                    <div className="sdo-report-request__reason-save-cancel" >
                                                        <i className="icon-Edit" onClick={e => handleEditRequestRecomm(params.row, e)} />
                                                        <span className="sdo-report-request__reason-save" onClick={e => handleEditRequestRecomm(params.row, e)}> {t('specialDayOff.sdoReport.save')} </span>
                                                        <i className="icon-close" onClick={e => handleCancelRequest(params.row.id, e)} />
                                                        <span onClick={e => handleCancelRequest(params.row.id, e)} > {t('specialDayOff.sdoReport.cancel')} </span>
                                                    </div>
                                                    <AcDialog open={open} onClose={handleClose} data={removeData} />
                                                </div>
                                            </>
                                            :
                                            <p >
                                                <div className='sdo-report-request__reason-item'>
                                                    <div>     {Number(params.row.updatedBy) !== -1 && !params.row?.isPreApproved && params.row.recommendedstatus !== positionReqStatusType.REVOKED ? <span style={{ fontWeight: 600, color: 'black !important' }}>Updated </span> : ''}
                                                        {Number(params.row.updatedBy) !== -1 && !params.row?.isPreApproved && params.row.recommendedstatus !== positionReqStatusType.REVOKED && params.row.reason && params.row.reason !== null && params.row.reason !== 'N/A' ? <span> -&nbsp;</span> : ''} </div>
                                                    <div>  {params.row.reason && params.row.reason !== null && params.row.reason !== 'N/A' ? params.row.reason : ''} </div>
                                                </div>
                                            </p>
                                        }

                                    </div>
                                </> : ''}
                        </div>
                    </>
                );
            }
        },
        {
            field: 'actions',
            width: !isIpadView
                ? !isAllPositions ? 140 : 190
                : !isAllPositions ? 200 : 190
            , editable: false,
             sortable: false ,
            disableClickEventBubbling: true,
            renderHeader : (params) => (
                <p><strong>
                    <Link className="mange-all-link" to={'/sdo-admin-ec'} state={{ setLimitTabZero: 1, month: sdoMonthYear.sdoMonth, year: sdoMonthYear.sdoYear, position: renderedPosition, isManageAllRedirect: true }}>
                        {isReqApproved(sdoReqList) ? t('specialDayOff.sdoReport.manageAll') : ''}
                    </Link>
                </strong>
                </p>),
            renderCell: (params) => {
                return (
                    params.row.recommendedstatus === positionReqStatusType.PENDING_DECLINE && params.row.reason.toUpperCase() === 'PAIRING' ? '' :
                    <>
                        <div style={{ cursor: "pointer" }}>
                            {!params.row.isPreApproved && (params.row.recommendedstatus === positionReqStatusType.PENDING_APPROVAL || params.row.recommendedstatus === positionReqStatusType.PENDING_DECLINE) ?
                                <>
                                    <div className="sdo-report-request__reason-container">
                                        {onEditClick && params.row.id === rowId ?
                                            <><div className="sdo-report-request__save-cancel">
                                                <div className="sdo-report-request__save"
                                                    onClick={e => handleEditRequestRecomm(params.row, e)}>
                                                    <i className="icon-Edit" />
                                                    <span> {t('specialDayOff.sdoReport.save')} </span>
                                                </div>
                                                <AcDialog open={open} onClose={handleClose} data={removeData} />
                                                <div className="sdo-report-request__cancel" onClick={e => handleCancelRequest(params.row.id, e)}>
                                                    <i className="icon-close" />
                                                    <span> {t('specialDayOff.sdoReport.cancel')} </span>
                                                </div>
                                            </div>
                                                <div className="sdo-report-request__decision-container" >
                                                    <div className="sdo-report-request-select-decision">
                                                        <FormControl className="select-dropdown">
                                                            <InputLabel id='inputLabel' className={dropDownClasses.label}>{t('specialDayOff.sdoReport.decision')}</InputLabel>
                                                            <Select
                                                                className={selectClass}
                                                                MenuProps={menuProps}
                                                                labelId="select-label-reason2"
                                                                value={decision}
                                                                input={<FilledInput />}
                                                                label={t('specialDayOff.sdoReport.decision')}
                                                                onChange={e => onChangeIpadDecision(e)}
                                                                disableUnderline
                                                                IconComponent={iconComponentIpadDecision}
                                                                open={openIpadDecision}
                                                                onClose={handleIpadOpenCloseDecision}
                                                                onOpen={handleIpadOpenCloseDecision}
                                                                defaultValue={t('specialDayOff.sdoReport.approve')}
                                                            >
                                                                {decisionList.map((decision, key) => (
                                                                    <MenuItem key={key} value={decision.name}>
                                                                        {decision.name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                    <div className="sdo-report-request-select-reason">
                                                        <FormControl className="select-dropdown">
                                                            <InputLabel id='inputLabel' className={dropDownClasses.label}>{t('specialDayOff.sdoReport.reason')}</InputLabel>
                                                            <Select
                                                                className={selectClass}
                                                                MenuProps={menuProps}
                                                                labelId="select-label-reason1"
                                                                value={reason}
                                                                input={<FilledInput />}
                                                                label={t('specialDayOff.sdoReport.reason')}
                                                                disableUnderline
                                                                IconComponent={iconComponentIpadReason}
                                                                open={openIpadReason}
                                                                onClose={handleIpadOpenCloseReason}
                                                                onOpen={handleIpadOpenCloseReason}
                                                                defaultValue={t('specialDayOff.sdoReport.na')}
                                                                onChange={e => onChangeIpadReason(e)}
                                                                disabled={disable}
                                                            >
                                                                {reasonList.map((reason, key) => (
                                                                    <MenuItem key={key} value={reason}>
                                                                        {reason}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                    <div className="sdo-report-request__reason-save-cancel">
                                                        <i className="icon-Edit" onClick={e => handleEditRequestRecomm(params.row, e)} />
                                                        <span className="sdo-report-request__reason-save" onClick={e => handleEditRequestRecomm(params.row, e)}> {t('specialDayOff.sdoReport.save')} </span>
                                                        <i className="icon-close" onClick={e => handleCancelRequest(params.row.id, e)} />
                                                        <span onClick={e => handleCancelRequest(params.row.id, e)}> {t('specialDayOff.sdoReport.cancel')} </span>
                                                    </div>
                                                    <AcDialog open={open} onClose={handleClose} data={removeData} />
                                                </div></>

                                            :
                                            <div className="sdo-report-request__edit" onClick={e => handleEditRequest(params.row, e)}>
                                                <i className="icon-edit" />
                                                <span > {t('specialDayOff.sdoReport.edit')} </span>
                                            </div>

                                        }
                                    </div>
                                </> : 
                                  (params.row.isPreApproved || params.row.recommendedstatus === positionReqStatusType.APPROVED) && <div className='sdo-report-request__manage'  onClick={e => handleManageClick(params.row,e)} >
                                    <i className="icon-manage_accounts_FILL0_wght400_GRAD0_opsz48-1-1 icon--x-large" />
                                    <span className='manage-lbl'  >{t('specialDayOff.sdoReport.manage')} </span>
                                </div>  
                                }
                        </div>
                    </>
                );
            }
        }
    ];

    return (

        <div className='sdo-rr-req-list__container' >

            {sdoReqList && sdoReqList?.reports && sdoReqList?.reports.length > 0 ?
                <>
                <DataGridPro
                    columnVisibilityModel={{
                        position: isAllPositions,
                        actions: status && status !== sdoCycleStatus.OPEN
                    }}
                    disableColumnMenu
                    disableRowSelectionOnClick
                    //disableSelectionOnClick
                    pagination
                    //disableExtendRowFullWidth={true}
                    rows={sdoReqList?.reports}
                    // pageSize={pageSize}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[25, 50, 100]}
                    // rowsPerPageOptions={rowsPerPageOptions}
                    // page={page}
                    // onPageSizeChange={(newPageSize) => handlePageSizeChange(newPageSize)}
                    columns={positionReqListColumns}
                    sortModel={sortModel}
                    slots={{ pagination: (props: any) =>
                            <>
                            {paginationModel.pageSize < sdoReqList?.reports?.length ?
                                <div className="enabled-view-all">
                                    <span onClick={showAllRows}>View All</span>
                                </div>
                                : sdoReqList?.reports?.length > 10 ?
                                    <div className="disabled-view-all">
                                        <span>View All</span></div>
                                    : <div className="disabled-view-all-adjusted">
                                        <span>View All</span></div>}
                            <GridPagination />
                            </>
                    }}
                    onSortModelChange={(model) => handleSortChange(model)}
                    // onPageChange={(page, details) => { setPage(page); }}
                />
                </>
                :
                <DataGridPro
                    autoHeight
                    disableColumnMenu
                    //disableSelectionOnClick
                    //disableExtendRowFullWidth={true}
                    rows={requestlistNoData}
                    columns={positionReqListColumns} />
            }
            
        </div>
        
    )
}


